import { AuthService } from './../services/auth.service';
import { IRequest } from './../models/request';
import { SortByOptions } from './../models/general.model';
import { AddStateAction, SetUserInfo } from './../store/general/actions';
import { getHeaderState, getUserInfo } from './../store/general/selectors';
import { GeneralState } from './../store/general/state';
import { Router } from '@angular/router';
import { IUser } from './../models/user.model';
import { Observable } from 'rxjs';
import { AuthState } from './../store/auth/auth.reducer';
import { isLoggedIn } from './../store/auth/auth.selectors';
// import { UserState } from './../store/search/state';
import { Store, select } from '@ngrx/store/';
import { Login, Logout } from '../store/auth/auth.actions';
import { IGeneralData } from '../models/general.model';
import { SocialAuthService } from 'angularx-social-login';

export abstract class Sandbox {
    protected loggedUser$: Observable<boolean>;
    protected headerType$: Observable<string>;

    constructor(protected appState$: Store<AuthState>,
        protected generalState$: Store<GeneralState>,
        private authService: AuthService,
        protected router: Router,
        protected socialAuth: SocialAuthService
                    ) {
        appState$.select(isLoggedIn).subscribe((v) => {
            this.loggedUser$ = v;
        });
        const userInfo = JSON.parse(localStorage.getItem('user'));
        let selectedUser = null;
        if (userInfo) {

            const user: IUser = {
                email: userInfo.email,
                id: userInfo.id,
                name: userInfo.name,
                surname: userInfo.surname,
                username: userInfo.username,
            };

            this.appState$.dispatch(new Login({user}));
            selectedUser = user;
        }

        if (selectedUser !== null) {
            this.authService.getUserById(selectedUser.id).subscribe( userInformation => {
                const newState: IGeneralData = {
                    footerType: null, headerType: 'Results',
                    id: 1, sortByOption: SortByOptions.SORT_BY_PRICE_ASC,
                    lastRequestAsked: this.createEmptyRequest(),
                    user: userInformation
                };
                this.generalState$.dispatch(new AddStateAction({data: newState}));
                this.generalState$.dispatch(new SetUserInfo(1, {user: userInformation}));
            });
        } else {
            const newState: IGeneralData = {
                footerType: null, headerType: 'Results',
                id: 1, sortByOption: SortByOptions.SORT_BY_PRICE_ASC,
                lastRequestAsked: this.createEmptyRequest(),
            };
            this.generalState$.dispatch(new AddStateAction({data: newState}));
        }
    }

   loginUser (user: IUser) {
    localStorage.setItem('user', JSON.stringify(user));
    this.appState$.dispatch(new Login({user}));
    // window.location.reload();
    this.generalState$.select(getUserInfo).subscribe(usr => {
        if (usr === null) {
            this.authService.getUserById(user.id).subscribe( userInformation => {
                this.generalState$.dispatch(new SetUserInfo(1, {user: userInformation}));
            });
        }
    });
   }

   logoutUser() {
    localStorage.removeItem('user');
    this.socialAuth.signOut(true);
    this.router.navigate(['/']);
    setTimeout(() => {
        window.location.reload();
    }, 500);
   }

   createEmptyRequest(): IRequest {
       const request: IRequest = {
        location: '', latitude: -1, longitude: -1, fromdate: '',
        todate: '', maxprice: -1, minprice: -1, rooms: 0,
        roompersons: [], roomLift: false, disableAccess: false, smoking: false,
        roomLiftOpt: false, disableAccessOpt: false, smokingOpt: '', starRating: -1,
        accomType: -1, mealType: -1, personalReq: '', requestExpiry: -1,
        hotelfacilities: '', hotelroomfacilities: '', opthotelfacilities: '',
        opthotelroomfacilities: '', hotelextras: [], userid: -1
       };
       return request;
   }
}
